export const NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS = "duplicateItemID";

export const PATHS = {
	SETUP: "/setup",
	TOP: "/",
	HOTEL: {
		TOP: "/:hotelID",
		CONTACT: {
			TOP: "/:hotelID/contact",
			NEW: "/:hotelID/contact/new_contact",
			CHAT_ROOM: "/:hotelID/contact/:contactID",
		},
		INVOICE_SYSTEM: { SETTINGS: "/:hotelID/invoiceSystem/settings" },
		MARKETING: {
			CAMPAIGN: {
				TOP: "/:hotelID/marketing/campaign",
				EDIT: "/:hotelID/marketing/campaign/gift/:campaignID/edit",
				NEW: "/:hotelID/marketing/campaign/new_gift",
				DETAILS: "/:hotelID/marketing/campaign/gift/:campaignID",
			},
			VOUCHER: {
				TOP: "/:hotelID/marketing/voucher",
				EDIT: "/:hotelID/marketing/voucher/edit/:voucherID",
				I18N: "/:hotelID/marketing/voucher/edit/:voucherID/:langCode",
				NEW: "/:hotelID/marketing/voucher/new",
			},
		},
		MANAGEMENT: {
			RESERVATION: {
				TOP: "/:hotelID/management/reservation/",
				DETAIL: "/:hotelID/management/reservation/:reservationID",
				CALENDAR: "/:hotelID/management/reservation/reservationCalendar",
				REQUEST_LIST: "/:hotelID/management/reservation/requestList",
				ADD: "/:hotelID/management/reservation/addReservation",
				EDIT: "/:hotelID/management/reservation/:reservationID/editReservation",
			},
			ACTIVITIES: { OPTIONS: "/:hotelID/management/activities/options" },
			SALES: {
				TOP: "/:hotelID/management/sales",
				RECEIPTS: "/:hotelID/management/sales/receipts",
			},
			REFUND_REQUEST: { TOP: "/:hotelID/management/refundRequest" },
			EC_SALES: {
				TOP: "/:hotelID/management/ecsales", // 旧管理画面と同じURL
				DETAIL: "/:hotelID/management/ecsales/:ecID", // 旧管理画面と同じURL
			},
		},
		ITEMS: {
			PLAN: {
				TOP: "/:hotelID/items/plan",
				STOCK: "/:hotelID/items/plan/stock",
				STOCK_DEPRECATED: "/:hotelID/items/plan/stock-deprecated", // 商品管理>プランのタブ用（廃止予定）
				RATE_MATRIX: "/:hotelID/items/plan/rate-matrix",
				EDIT: {
					PLAN_ID: {
						DEFAULT: "/:hotelID/items/plan/edit/:planID",
						I18N: "/:hotelID/items/plan/edit/:planID/:langCode",

						DAYTRIP: {
							DEFAULT: "/:hotelID/items/plan/edit/:planID/dayTrip",
							I18N: "/:hotelID/items/plan/edit/:planID/dayTrip/:langCode",
						},
					},
					NEW: {
						PLAN: {
							STANDARD: "/:hotelID/items/plan/edit/new/plan",
							DAYTRIP: "/:hotelID/items/plan/edit/new/dayTrip",
						},
					},
				},
			},
			ROOM: {
				TOP: "/:hotelID/items/room",
				STOCK: "/:hotelID/items/room/stock",
				STOCK_DEPRECATED: "/:hotelID/items/room/stock-deprecated", // 商品管理>部屋のタブ用（廃止予定）
				PRICE_RANK: "/:hotelID/items/room/price", // URLは旧管理画面と同じものを設定（新管理画面の 実装 には price-rank を用いている）
				PRICE_RANK_DEPRECATED: "/:hotelID/items/room/price-deprecated", // 商品管理>部屋のタブ用（廃止予定）
				EDIT: {
					ROOM_ID: {
						DEFAULT: "/:hotelID/items/room/edit/:roomID",
						I18N: "/:hotelID/items/room/edit/:roomID/:langCode",
						DUMMY: "/:hotelID/items/room/edit/:roomID/dummy",
					},
					NEW: {
						ROOM: { DEFAULT: "/:hotelID/items/room/edit/new/room" },
						DUMMY: { DEFAULT: "/:hotelID/items/room/edit/new/dummy" },
					},
				},
			},
			OPTION: {
				TOP: "/:hotelID/items/option",
				STOCK: "/:hotelID/items/option/stock",
				STOCK_DEPRECATED: "/:hotelID/items/option/stock-deprecated", // 商品管理>オプションのタブ用（廃止予定）
				EDIT: {
					OPTIONS_ID: {
						DEFAULT: "/:hotelID/items/option/edit/:optionID",
						I18N: "/:hotelID/items/option/edit/:optionID/:langCode",
					},
					NEW: { OPTION: { DEFAULT: "/:hotelID/items/option/edit/new/option" } },
				},
			},
			DISCOUNT: {
				TOP: "/:hotelID/items/discount",
				NEW: "/:hotelID/items/discount/new/:type",
				EDIT: "/:hotelID/items/discount/:discountID/:type",
				DUPLICATE: "/:hotelID/items/discount/new/:type/:duplicateDiscountID",
			},
		},
		HOTEL_SETTINGS: {
			EDIT: { DEFAULT: "/:hotelID/hotelSettings/edit", I18N: "/:hotelID/hotelSettings/edit/:langCode" },
			HOTEL_POLICY: {
				TOP: "/:hotelID/hotelSettings/hotelPolicy",
				I18N: "/:hotelID/hotelSettings/hotelPolicy/:langCode",
			},
			MAIL_SETTINGS: {
				TOP: "/:hotelID/hotelSettings/mailSettings",
				I18N: "/:hotelID/hotelSettings/mailSettings/:langCode",
			},
			EMAIL: "/:hotelID/hotelSettings/email",
		},
		HPB: { LIST: "/:hotelID/hpb", EDIT: { UUID: "/:hotelID/hpb/edit/:uuid", NEW: "/:hotelID/hpb/edit" } },
		RESERVATION_PAGE: {
			BASE: "/:hotelID/reservationPage/base",
			MAGAZINE: {
				LIST: {
					PLAN: "/:hotelID/reservationPage/magazine/plan",
					ROOM: "/:hotelID/reservationPage/magazine/room",
					HOTEL: "/:hotelID/reservationPage/magazine/about",
				},
				SETTING: "/:hotelID/reservationPage/magazine/setting",
				EDIT: {
					DEFAULT: "/:hotelID/reservationPage/magazine/edit",
					I18N: "/:hotelID/reservationPage/magazine/edit/:langCode",
				},
			},
			SNACK: {
				LIST: "/:hotelID/reservationPage/snack/design/list",
				SETTING: "/:hotelID/reservationPage/snack/design/list/snackMenu",
				EDIT: {
					UUID: "/:hotelID/reservationPage/snack/design/edit/:uuid",
					NEW: "/:hotelID/reservationPage/snack/design/edit",
				},
			},
		},
		SELECT_HOTEL_TEMPLATE: "/:hotelID/selectHotelTemplate",
		START_GUIDE_CHECKLIST: "/:hotelID/start-guide-checklist",
	},
	POLICY: {
		PRIVACY_POLICY: "/policy/privacyPolicy",
		SERVICE_POLICY: "/policy/servicePolicy",
		COMMERCIAL_TRANSACTIONS_LAW: "/policy/commercialTransactionsLaw",
	},
	SETTINGS: {
		PAYMENT_CREDIT: "/:hotelID/settings/paymentCredit",
		PAYMENT_DEPOSIT_ACCOUNT: "/:hotelID/settings/paymentDepositAccount",
		BILLING: "/:hotelID/settings/billing",
		SITE_CONTROLLER: "/:hotelID/settings/siteController",
		SECURITY: "/:hotelID/settings/security",

		EXTERNAL_CONNECTION: {
			SITE_EMBED: "/:hotelID/externalConnection/site-embed",
			GOOGLE_FREE_BOOKING_LINKS: {
				DEFAULT: "/:hotelID/externalConnection/googleFreeBookingLinks",
				I18N: "/:hotelID/externalConnection/googleFreeBookingLinks/:langCode",
			},
		},
	},
	CANCELLATION: "/:hotelID/cancellation",
	FAQ: "/:hotelID/faq",
	FAQ_DETAIL: "/:hotelID/faq/:notionID",
	AUTH: {
		SIGN_IN: "/auth/signIn",
		SIGN_UP: "/auth/signUp",
		VERIFY_YOUR_EMAIL: "/auth/verifyYourEmail",
		VERIFY_MFA_OTP: "/auth/verifyMfaOtp",
		VERIFY: "/auth/verify",
		RESET_PASSWORD: "/auth/resetpassword",
		FORGOT_PASSWORD: "/auth/forgotpassword",
		INVITATION: {
			VERIFY: "/auth/invitation/verify",
			ONE_TIME_PASS: "/auth/invitation/:companyID/:oneTimePass",
		},
	},
} as const;
